import React from "react";
import { Switch, Route } from "react-router-dom";
import TestPage from "./pages/TestPage";
import StartPage from "./pages/StartPage";
import TutorialPage from "./pages/TutorialPage";
import ProblemViewPage from "./pages/ProblemViewPage";
import ResultPage from "./pages/ResultPage";
import LoadingPage from "./pages/LoadingPage";
import APITestPage from "./pages/APITestPage";
import ResultPaperPage from './pages/ResultPaperPage'
import "./App.css";

const App = () => {
  // 학습기에서 접근시 window.Android 객체를 전달해줌.
  // window.Android는 웹뷰의 종료(window.Android.exit()) 및 자체 정의한 컨펌창 메소드(window.Android.confirm())가 있음
  if (window.Android) {
    window.funcYes = () => {
      window.Android.exit();
    };
    window.funcNo = () => {};
  }
  window.handleConfirm = () => {
    window.Android &&
      window.Android.confirm(
        "진단평가를 종료하시겠습니까?",
        "funcYes()",
        "funcNo()",
        "예",
        "아니요"
      );
  };

  // 진단평가 도중 뒤로가기를 눌렀을 때 진단검사가 꼬이는 상황이 발생
  // 뒤로가기를 방지하는 코드
  // 학습기에선 뒤로가기를 막고 종료 컨펌을 띄우게 되어 있으므로 종료 컨펌 표시
  window.onpopstate = (event) => {
    window.history.pushState(null, null, window.location.href);
    if (window.Android) {
      window.handleConfirm();
    }
  };

  return (
    <Switch>
      {window.location.hostname === "ai-scanning.home-learn.co.kr" ? null : (
        <Route component={TestPage} path="/" exact />
      )}
      {window.location.hostname === "ai-scanning.home-learn.co.kr" ? null : (
        <Route component={APITestPage} path="/apitest" exact />
      )}
      <Route component={StartPage} path="/diagnosis/" exact />
      <Route component={StartPage} path="/diagnosis/homepage/:hp_token" exact />
      <Route component={TutorialPage} path="/diagnosis/tutorial/" exact />
      <Route
        component={ProblemViewPage}
        path="/diagnosis/problem-view/"
        exact
      />
      <Route component={LoadingPage} path="/diagnosis/loading/" exact />
      <Route component={ResultPage} path="/diagnosis/result/" exact />
      <Route component={ResultPage} path="/diagnosis/result/:token" exact />
      <Route component={ResultPaperPage} path="/diagnosis/resultpaper/:token" exact />
      <Route
        component={({ location }) => (
          <div>
            <h2>Not Found 404</h2>
            <p>{location.pathname}</p>
          </div>
        )}
      />
    </Switch>
  );
};

export default App;
